import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { HelperService } from '../../core/services/helper.service';

@Component({
  selector: 'app-price-list',
  templateUrl: './price-list.component.html',
  styleUrls: ['./price-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PriceListComponent {
  private readonly helperService = inject(HelperService);
  private readonly translocoService = inject(TranslocoService);

  constructor() {
    const pageTitle = this.translocoService.translate('settings/priceList');
    this.helperService.setTitle(null, pageTitle);
  }
}
